/**
 * One frozen object per distinct VALUE, so an object-valued renderer option
 * keeps its identity across room snapshots.
 *
 * `ProceduralObject` compares its options shallowly, and every room snapshot
 * hands out fresh objects; an object-valued option (a pillow's own shape, the
 * duvet a throw lies on, a staged bed's headboard) would otherwise rebuild the
 * piece on every room write. Values are small and few per room (a dozen
 * pillow shapes), so the cache stays small.
 */

const byValue = new Map();

/**
 * @param {object|null|undefined} value  JSON-shaped
 * @returns {object|null} the same frozen object for every equal value
 */
function internByValue(value) {
  if (value == null) return null;
  const key = JSON.stringify(value);
  if (!byValue.has(key)) byValue.set(key, Object.freeze(JSON.parse(key)));
  return byValue.get(key);
}

module.exports = { internByValue };
